module.exports = __webpack_public_path__ + "assets/images/05HL.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/05HL.png
// module id = 1264
// module chunks = 1